import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading3XL,
} from "../../../typography";

import { CAREERS_URL } from "../../navigation/config/navConfig";
import { FeatureSectionType } from "../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { RiveAnimation } from "../ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { cn } from "@verse_core/shared_components/ClassName";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

export const FeatureSection = ({
  src,
  fallbackSrc,
  title,
  description,
  features,
  className,
  hasButton,
  imageClassName,
  textClassName,
  hasJobOpeningsButton,
  buttonText,
}: FeatureSectionType) => {
  return (
    <div
      className={cn(
        "tw-z-20 tw-flex tw-w-full tw-flex-col-reverse tw-items-center tw-justify-between tw-gap-x-[2em] tw-px-[1em] min440:tw-flex-row min440:tw-gap-y-[2.625em]",
        className,
      )}
    >
      <div className="tw-flex tw-h-full tw-w-full tw-flex-grow tw-flex-col tw-items-center tw-gap-y-[2em] min440:tw-w-2/5">
        <RiveAnimation
          src={src}
          fallbackSrc={fallbackSrc}
          className={cn("tw-h-fit tw-w-full", imageClassName)}
          fallbackClassName={cn("tw-h-fit tw-w-full", imageClassName)}
        />
      </div>
      <div className="tw-mb-[1.5em] tw-flex tw-w-full tw-flex-col tw-gap-y-[2em] min440:tw-w-3/5">
        <Heading3XL
          className={cn(
            "tw-my-0 tw-hidden tw-text-blue-dark-3 min440:tw-flex",
            textClassName,
          )}
        >
          {title}
        </Heading3XL>
        <Heading2XL
          className={cn(
            "tw-my-0 tw-text-blue-dark-3 min440:tw-hidden",
            textClassName,
          )}
        >
          {title}
        </Heading2XL>
        {description.map((paragraph, index) => (
          <Fragment key={`description-xl-${index}`}>
            <BodyXL
              className={cn(
                "tw-my-0 tw-hidden tw-text-gray-2 min440:tw-flex",
                textClassName,
              )}
            >
              {paragraph}
            </BodyXL>
            <BodyLG
              className={cn(
                "tw-my-0 tw-text-gray-2 min440:tw-hidden",
                textClassName,
              )}
            >
              {paragraph}
            </BodyLG>
          </Fragment>
        ))}
        {features.length > 0 && (
          <div className="tw-flex tw-flex-col tw-gap-y-[1.5em]">
            {features.map((feature, index) => (
              <FeatureItem
                key={index}
                icon={feature.icon}
                text={feature.text}
              />
            ))}
          </div>
        )}
        {hasButton && (
          <StandardButton
            onClick={() => {}}
            style={"primary-blue"}
            className="tw-mb-[2.625em] tw-mt-0 tw-w-[13.75em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
          >
            <Link to="/contact" className="tw-no-underline">
              <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
                {buttonText ? buttonText : "Get a demo"}
              </BodyLGB>
              <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
                {buttonText ? buttonText : "Get a demo"}
              </BodyMDB>
            </Link>
          </StandardButton>
        )}
        {hasJobOpeningsButton && (
          <a
            href={CAREERS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="tw-no-underline"
          >
            <StandardButton
              onClick={() => {}}
              style={"primary-blue"}
              className="tw-flex tw-w-[15em] tw-items-center tw-justify-center tw-gap-x-[.5em] tw-rounded-full tw-px-[2em] tw-py-[1.25em] tw-text-[16px] min440:tw-mt-[1em]"
            >
              <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
                View job openings
              </BodyLGB>
              <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
                View job openings
              </BodyMDB>
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                className="tw-h-[1em] tw-w-[1em]"
              />
            </StandardButton>
          </a>
        )}
      </div>
    </div>
  );
};

const FeatureItem = ({ icon, text }: { icon: string; text: string }) => (
  <div className="tw-flex tw-items-start tw-gap-x-[1em]">
    <img
      src={icon}
      className="tw-mt-[.25em] tw-h-[1em] tw-w-[1em] min440:tw-h-[1.5em] min440:tw-w-[1.5em]"
    />
    <BodyXL className="tw-my-0 tw-hidden tw-text-gray-2 min440:tw-flex">
      {text}
    </BodyXL>
    <BodyLG className="tw-my-0 tw-text-gray-2 min440:tw-hidden">{text}</BodyLG>
  </div>
);
